var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "xp1qr2qrfa",
    d: "M0 0h27.975v14.976H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.563c.082-.585.147-1.174.25-1.756A14.18 14.18 0 0 1 2.752 6.92c.03-.04.067-.076.123-.14l4.08 3.05c-2.123 3.464-2.501 7.073-.747 10.745 1.755 3.676 4.799 5.653 8.833 6.184v5.13c-.475-.04-.949-.052-1.415-.12-5.419-.788-9.207-3.832-11.735-8.567C.82 21.198.223 19.04.052 16.77.045 16.678.018 16.59 0 16.5v-1.937",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.025)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rieau1ep0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xp1qr2qrfa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.975 14.973h-2.079c-.936 0-1.873-.002-2.81.003-.174 0-.288-.012-.307-.237-.328-3.841-2.352-6.554-5.693-8.3-2.863-1.497-5.876-1.802-8.97-.744-1.463.5-2.715 1.34-3.778 2.463-.064.068-.136.129-.23.218L0 5.298a13.722 13.722 0 0 1 2.839-2.65C5.88.538 9.27-.247 12.928.066c3.75.322 7.078 1.693 9.926 4.159 2.736 2.37 4.418 5.345 4.95 8.943.087.581.113 1.172.171 1.805",
    fill: "#FFF",
    opacity: 0.473,
    mask: "url(#rieau1ep0b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.953 26.824c.924-.235 1.85-.377 2.706-.704 3.968-1.52 6.332-4.397 7.077-8.586.123-.692.105-.695.81-.695h4.397c-.265 7.73-6.845 14.672-14.99 15.012v-5.027z",
    fill: "#FFF",
    opacity: 0.473
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.317 19.979v-8.187c0-.69.227-.915.914-.915.573 0 1.145-.005 1.717.001.45.006.725.272.725.72.005 2.756.002 5.512.001 8.268 0 .03-.008.06-.016.113h-3.34zM12.563 19.996c-.938 0-1.84.011-2.743-.005a.61.61 0 0 1-.585-.62 265.64 265.64 0 0 1 0-4.272c.003-.365.265-.619.646-.63.675-.02 1.351-.019 2.026 0 .382.01.649.263.651.624.011 1.621.005 3.242.005 4.903M19.432 16.69c.005-.363.277-.626.643-.634a27.413 27.413 0 0 1 1.93.01c.594.03.79.26.792.853.002.79-.004 1.578-.015 2.368-.006.403-.263.701-.64.707-.892.014-1.784.005-2.715.005 0-1.13-.009-2.22.005-3.31z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVolume);
export default __webpack_public_path__ + "static/media/ic-volume.28646a5c97701a48ed86b5431fabd5f0.svg";
export { ForwardRef as ReactComponent };